import { models } from 'powerbi-client';
import { PowerBiReportSettings } from '@/Infrastructure/Configuration/types';

export const buildPBiSplashEmbedConfig = (
  { workspaceId, reportId, pageName }: PowerBiReportSettings,
  terminalNumber: string
): models.IReportEmbedConfiguration => ({
  type: 'report',
  id: reportId,
  embedUrl: `https://app.powerbi.com/reportEmbed?reportId=${reportId}&groupId=${workspaceId}`,
  pageName,
  filters: [
    {
      $schema: 'http://powerbi.com/product/schema#basic',
      target: { table: 'dim_site', column: 'sit_code' },
      operator: 'In',
      values: [terminalNumber],
      filterType: models.FilterType.Basic
    }
  ],
  settings: {
    panes: {
      filters: { visible: false },
      pageNavigation: { visible: false }
    },
    background: models.BackgroundType.Transparent,
    // Scales the page to the container so it never scrolls or clips, whatever size the container is
    layoutType: models.LayoutType.Custom,
    customLayout: { displayOption: models.DisplayOption.FitToPage }
  }
});
